/**
 * Adds a function to be called when the document is loaded, or immediately
 * if the document is already loaded.
 * @param callback - The function to execute
 */
export default function(callback) {
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}
